<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="150px"
      class="form form-medium"
    >
      <el-form-item label="活动类型">
        <el-radio v-model="post.activity_type" :label="0" :disabled="isSaving">积分翻倍</el-radio>
        <el-radio v-model="post.activity_type" :label="1" :disabled="isSaving">累计签到</el-radio>
      </el-form-item>
      <el-form-item label="活动标题" prop="title">
        <el-input
          v-model="post.title"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入积分活动标题"
        />
      </el-form-item>

      <template v-if="post.activity_type === integralActivityTypes.double.value">
        <el-form-item label="签到积分" prop="integral">
          <v-input-money
            placeholder="请输入活动期间每次签到所得积分"
            v-model="post.integral"
            :is-show-suffix="true"
            suffix-name="分"
            :min="1"
            :max="8"
          />
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="post.start_time"
            :picker-options="pickerOptionsOfAfterSystemStartDay"
            type="datetime"
            placeholder="请选择活动开始时间"
            value-format="timestamp"
          />
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="post.end_time"
            :picker-options="endTimeOptions"
            type="datetime"
            placeholder="请选择活动结束时间"
            value-format="timestamp"
          />
        </el-form-item>
      </template>

      <template v-if="post.activity_type === integralActivityTypes.accumulate.value">

        <el-form-item label="活动描述" prop="brief">
          <el-input
            v-model="post.brief"
            maxlength="64"
            show-word-limit
            clearable
            placeholder="请输入积分活动标题之下的描述"
          />
        </el-form-item>

        <v-image-upload
          v-model="post.banner"
          label="活动轮播图"
          prefix="integral-activity"
          ratio="3:1"
          prop-name="banner"
        />

        <v-image-upload
          v-model="post.cover"
          label="活动封面"
          prefix="integral-activity"
          ratio="1.32:1"
          prop-name="cover"
        />

        <el-form-item label="活动细则" prop="rule">
          <el-input
            type="textarea"
            :autosize="{ minRows: 8 }"
            placeholder="请输入 1 ~ 2000 字的活动细则"
            v-model="post.rule"
            maxlength="2000"
            show-word-limit
          />
        </el-form-item>
      </template>

      <el-form-item label="不在轮播图展示">
        <el-switch v-model="post.is_hide_in_list" :active-value="1" :inactive-value="0"/>
        <el-alert
          title="积分活动默认会在小程序课表页进行轮播图展示，开启此功能后，将不进行轮播图展示"
          type="info"
          show-icon
          :closable="false"
          class="alert-box"
        />

      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.integralActivityList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { pickerOptionsOfAfterSystemStartDay } from '@/utils/formats';
import { store } from '@/api/integral-activity';
import { toCent, toSecond } from '@/filters';
import { integralActivityTypes } from '@/enums/integralActivityTypes';

export default {
  name: RouteConfig.integralActivityAdd.name,
  data: () => ({
    RouteConfig,
    pickerOptionsOfAfterSystemStartDay,
    integralActivityTypes,
    isSaving: false,
    post: {
      activity_type: 0,
      title: '',
      brief: '',
      banner: '',
      cover: '',
      rule: '',
      integral: '',
      signed_count: '',
      start_time: '',
      end_time: '',
      is_hide_in_list: 0,
    },
    endTimeOptions: {
      disabledDate: null,
    },
    rules: {
      title: [{ required: true, message: '请输入 1 ~ 14 个字符的活动标题', trigger: 'change' }],
      banner: [{ required: true, message: '请上传活动轮播图', trigger: 'change' }],
      cover: [{ required: true, message: '请上传活动封面', trigger: 'change' }],
      brief: [{ required: true, message: '请输入 1 ~ 64 个字符的活动描述', trigger: 'change' }],
      rule: [{ required: true, message: '请输入 1 ~ 2000 个字符的活动细则', trigger: 'change' }],
      signed_count: [{ required: true, message: '请输入 1 ~ 500 范围内的累计签到次数', trigger: 'change' }],
      integral: [{ required: true, message: '请输入 1 ~ 1000 范围内的积分', trigger: 'change' }],
      start_time: [{ required: true, message: '请输入活动开始时间', trigger: 'change' }],
      end_time: [{ required: true, message: '请输入活动结束时间', trigger: 'change' }],
    },
  }),
  watch: {
    'post.start_time'(time) {
      if (this.post.end_time <= time) this.post.end_time = '';
    },
  },
  created() {
    this.endTimeOptions.disabledDate = (time) => {
      return time.getTime() <= this.post.start_time;
    };
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const post = { ...this.post };
        post.start_time = toSecond(post.start_time);
        post.end_time = toSecond(post.end_time);
        post.integral = toCent(post.integral);
        post.signed_count = toCent(post.signed_count);
        const { isError } = await store(post);
        this.isSaving = false;
        if (!isError) RouteConfig.integralActivityList.push();
      });
    },
  },
};
</script>
